import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import dangerouslyComposeProps from "./components/SearchContents/dangerouslyComposeProps";
import { SearchContentsProps } from "./components/SearchContents/SearchContents";
import reportWebVitals from "./reportWebVitals";

const rootSelector = ".js-planning-search-app";
const rootElement = document.querySelector(rootSelector);
const root = ReactDOM.createRoot(rootElement as Element);

const props: SearchContentsProps = dangerouslyComposeProps(rootElement);

if (root) {
    const router = createBrowserRouter(
        [
            {
                path: "/",
                element: <App {...props} />,
            },
        ],
        {
            // basename: props.routerBasename,
            basename: window.location.pathname,
        }
    );

    root.render(
        <React.StrictMode>
            <RouterProvider router={router} />
        </React.StrictMode>
    );

    // https://create-react-app.dev/docs/measuring-performance/
    reportWebVitals();
}
